import React from 'react';

import { faClass } from '@/constants/icons';

import styles from './SegmentedControl.module.scss';

/**
 * Controllo segmentato a pill per le sotto-viste (es. Storico: Pianificati/
 * Viaggi/Fatture; Comunicazioni: Email/Telefonate). Più leggero dei tab e senza
 * il problema dei tab-dentro-tab. Coerente con `ViewToggle` (stessi token).
 *
 * Props:
 * - options: array { value, label, icon?, badge? }
 * - value:   value attivo
 * - onChange:(value) => void
 * - ariaLabel: etichetta del gruppo
 * - variant: 'pill' (default) | 'solid' — bordo primary e opzione attiva piena,
 *   per una scelta di form (es. «Orario fisso: Presa / Arrivo»)
 */
export default function SegmentedControl({
  options = [],
  value,
  onChange,
  ariaLabel,
  variant = 'pill',
}) {
  return (
    <div
      className={`${styles.seg} ${variant === 'solid' ? styles.solid : ''}`.trim()}
      role="tablist"
      aria-label={ariaLabel}
    >
      {options.map((opt) => {
        const active = value === opt.value;
        return (
          <button
            key={opt.value}
            type="button"
            role="tab"
            aria-selected={active}
            className={`${styles.segBtn} ${active ? styles.active : ''}`}
            onClick={() => !active && onChange?.(opt.value)}
          >
            {opt.icon && <i className={faClass(opt.icon)} aria-hidden="true" />}
            <span className={styles.label}>{opt.label}</span>
            {opt.badge != null && opt.badge !== '' && (
              <span className={styles.badge}>{opt.badge}</span>
            )}
          </button>
        );
      })}
    </div>
  );
}
